import { defaultClassroomDetails } from '@core/services';
import { ClassroomDetailsType, Subject } from 'lingo2-models';
import { ClassroomCardActionsEnum, ClassroomTabsEnum, IClassroomCardOption, IClassroomTabOption } from './models';

export const VISIBLE_AVATARS_COUNT = 3;

export const classroomDetails: ClassroomDetailsType[] = [...defaultClassroomDetails, 'user_service'];

export const daysOfWeek = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

export const menuOptions: IClassroomCardOption[] = [
  {
    id: ClassroomCardActionsEnum.pin,
    label: 'classrooms.menu.pin',
    enabled: (classroom, state) => !!classroom && !state.is_pined,
  },
  {
    id: ClassroomCardActionsEnum.unpin,
    label: 'classrooms.menu.unpin',
    enabled: (classroom, state) => !!classroom && state.is_pined,
  },
  {
    id: ClassroomCardActionsEnum.edit,
    label: 'classrooms.menu.edit',
    enabled: (classroom) => classroom?.can?.edit,
  },
  {
    id: ClassroomCardActionsEnum.invite,
    label: 'classrooms.menu.invite',
    enabled: (classroom) => classroom?.can?.invite,
  },
  {
    id: ClassroomCardActionsEnum.leave,
    label: 'classrooms.menu.leave',
    enabled: (classroom) => classroom?.can?.leave,
  },
  // {
  //   id: ClassroomCardActionsEnum.break_contract,
  //   label: 'classrooms.menu.leave',
  //   enabled: (classroom) => classroom?.user_service_contract?.can?.break,
  // },
  {
    id: ClassroomCardActionsEnum.archive,
    label: 'classrooms.menu.delete',
    enabled: (classroom) => classroom?.can?.archive,
  },
  {
    id: ClassroomCardActionsEnum.restore,
    label: 'classrooms.menu.restore',
    enabled: (classroom) => classroom?.can?.restore,
  },
  // DONE classroom?.can?.edit = /** Могу изменить общие сведения */
  // DONE classroom?.can?.invite = /** Могу пригласить участников */
  // TODO classroom?.can?.withdrawInvitation = /** могу отозвать приглашение */
  // TODO classroom?.can?.acceptInvitation = /** Могу принять приглашение */
  // TODO classroom?.can?.declineInvitation = /** Могу отклонить приглашение */
  // classroom?.can?.join = /** Могу присоединиться (по ссылке) */
  // OK classroom?.can?.leave = /** Могу покинуть */
  // classroom?.can?.authJoin = /** Смогу присоединиться (по ссылке) после авторизации */
  // classroom?.can?.authPaidJoin = /** Смогу присоединиться (по ссылке) с оплатой после авторизации */
  // DONE classroom?.can?.archive = /** Могу архивировать */
  // DONE  classroom?.can?.restore = /** Могу восстановить из архива */
  // TODO classroom?.can?.schedule_meeting = /** Могу создать митинг */
  // TODO classroom?.can?.manage_content = /** Могу управлять контентом в комнате */
  // TODO classroom?.can?.manage_tasks = /** Могу назначать и проверять задания для участников комнаты */
  // TODO classroom?.can?.assign_assistant = /** Могу назначать ассистента */
  // TODO classroom?.can?.assign_replacement_teacher = /** Могу назначать преподавателя на замену */
  // TODO classroom?.can?.join_user_service_contract = /** Могу записаться на услугу */
  // DONE classroom?.can?.break_user_service_contract = /** Могу прекратить занятия по услуге */
  // DONE classroom?.can?.chat = /** Могу пользоваться чатом */
];

export const tabs: IClassroomTabOption[] = [
  {
    order: 0,
    id: 0,
    title: 'classrooms.classroom-page.tabs.meetings',
    code: ClassroomTabsEnum.meetings,
    type: 'subject',
    item: new Subject(),
    total_count: 0,
  },
  {
    order: 1,
    id: 1,
    title: 'classrooms.classroom-page.tabs.publications',
    code: ClassroomTabsEnum.content,
    type: 'subject',
    item: new Subject(),
    total_count: 0,
  },
  {
    order: 2,
    id: 2,
    title: 'classrooms.classroom-page.tabs.participants',
    code: ClassroomTabsEnum.participants,
    type: 'subject',
    item: new Subject(),
    total_count: 0,
  },
];
